<script>
    import R, {LOADER} from "../lib/requests";
    import {formatDate, millisecondsToHours} from "../lib/lib";
    import Modal from '../components/modal/Modal.svelte';
    import ColoredNameControl from "../components/controls/ColoredNameControl.svelte";
    import PriceControl from "../components/controls/PriceControl.svelte";
    import TagsControl from "../components/controls/TagsControl.svelte";
    import Checkbox from "../components/controls/Checkbox.svelte";
    import Notifier from "../stores/notifier";
    import TaskPriceControl from "./TaskPriceControl.svelte";

    export let tasks = null;
    export let closeCallback;

    let task = null;
    let mergedTasks = null;
    let startDate = null;
    let startTime = null;
    let endTime = null;

    const load = () => {
        const onSuccess = result => {
            task = result.task;
            mergedTasks = result.merged_tasks;
            let dt = new Date(task.start_at);
            dt.setMilliseconds(dt.getMilliseconds() + task.duration);
            task.end_at = formatDate(dt, 'y-m-d H:i:s');
            startDate = formatDate(task.start_at, 'd-m-y');
            startTime = formatDate(task.start_at, 'H:i');
            endTime = formatDate(task.end_at, 'H:i');
            console.log("task", task);
        }

        const onFailure = err => {
            // Alert.warning("Χρέωση", err.message);
        };

        R.handle(R.task.initializeMerge, tasks, onSuccess, onFailure, LOADER.POPUP);
    }

    const save = () => {
        const onSuccess = result => {
            Notifier.showMessage("Οι εργασίες συγχωνεύτηκαν");
            close(result);
        }

        const onFailure = err => {
        };

        R.handle(R.task.merge, {task, merged_tasks:mergedTasks}, onSuccess, onFailure);
    }

    const close = (param) => {
        task = null;

        if (param instanceof Event) {
            closeCallback();
            return;
        }

        setTimeout(() => {
            closeCallback(param);
        }, 200);
    }

    load();
</script>
{#if task}
    <Modal title="Συγχώνευση εργασιών" icon="layers" modalSm closeOnEscape="{ true }" on:close="{ close }">
        <div slot="body">
            <h5 class="mb-3">{ task.name }</h5>
            <div class="form-control mb-3">
                <ColoredNameControl name="{ task.project.name }" color="{ task.project.color }" colorName/>
            </div>
            <div class="row">
                <div class="col-6">
                    <div class="form-control text-gray text-center px-0 mb-3">
                        { startDate }
                    </div>
                </div>
                <div class="col-6">
                    <div class="form-control text-gray text-center px-0 mb-3">
                        { startTime } - { endTime }
                    </div>
                </div>
                <div class="col-12">
                    <div class="form-control text-gray fw-semibold text-center px-0 mb-3">
                        { millisecondsToHours(task.duration) }
                    </div>
                </div>
            </div>
            <div class="form-group mb-4">
                <label>Χρέωση</label>
                <TaskPriceControl bind:value={task.price} projectId={task.project_id} duration={task.duration}  />
            </div>
            <div class="form-group">
                <TagsControl bind:tags={ task.tags } clockingTask/>
            </div>
            <hr class="full-hr">
            <div class="text-end">
                <div class="btn btn-link me-2" on:click="{ () => close() }">Κλείσιμο</div>
                <button class="btn btn-primary" on:click={ save }>Συγχώνευση</button>
            </div>
        </div>
    </Modal>
{/if}

<style>
    .from-to {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .from-to .from, .from-to .to {
        width: calc(50% - 12px);
        text-align: center;
    }

    .from-to .range {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
</style>